import { Directive, Input } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[CustomValidatorDirective]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CustomValidatorDirectiveDirective, multi: true }],
    standalone: false
})
export class CustomValidatorDirectiveDirective implements Validator {

  @Input('CustomValidatorDirective') CustomValidatorDirective:AbstractControl[];

  constructor()   { }
  validate(control: AbstractControl): ValidationErrors | null {

      let index = this.CustomValidatorDirective.indexOf(control);     

      if ( control.errors != null && index ==-1 && control.invalid){
        this.CustomValidatorDirective.push(control);
      }else{
        if ( index >-1){
          this.CustomValidatorDirective.splice(index,1);
        }
      }
      
      return null;
  }
  registerOnValidatorChange?(fn: () => void): void {
  }


}
